import * as React from 'react';
import { Grid } from '@material-ui/core';
import FreezeByDay from './reports/FreezeByDay';
import CancelsByDay from './reports/CancelsByDay';
import CreatesByDay from './reports/CreatesByDay';
import NetByDay from './reports/NetByDay';

interface Props {

};


const ReportsHome: React.FC<Props> = (prop: Props) => {

    
    //const { user, setUser } = useContext(AuthContext);
   
        return (
                <div>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <FreezeByDay />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <CancelsByDay />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <CreatesByDay />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <NetByDay />
                    </Grid>
                </Grid>
                </div>

                )
    }


export default ReportsHome;